<template>
  <div class="page-product-table-box">

    <div class="tablebox" v-if="viewmodel == 2">
      <el-table 
        :cell-style="getTableCellStyle"
        v-loading="tableloading" 
        ref="multipleTable" 
        :data="tableData"
        tooltip-effect="dark" 
        style="width: 100%"
        size="mini"
        @sort-change="sortthiscolumn"
        @expand-change="getProductList"
        :expand-row-keys="expands"
        :row-key="getRowKeys"
        :key="2"
      >
        <el-table-column width="30" type="expand">
          <template slot-scope="scope">
            <div class="tablebox">
              <el-table 
                :cell-style="getTableCellStyle"
                v-loading="tableloading1" 
                ref="multipleTable" 
                :data="tableDataSku[scope.row.index]"
                tooltip-effect="dark" 
                style="width: 100%"
                @sort-change="sortthiscolumn"
                size="mini"
              >
                <el-table-column prop="AssetId" label="ASSETID" width="110" show-overflow-tooltip></el-table-column>
                <el-table-column :label="$t('jgjk.s15')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <a :href="scope.row.URL" target="_blank">{{ scope.row.ProductName }}</a>
                  </template>
                </el-table-column>
                <el-table-column prop='SkuMap' :label="$t('jgjk.s266')" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" sortable='custom' prop='SkuTotalAmountStr' :label="$t('jgjk.s267')" width="110"></el-table-column>
                <el-table-column sortable='custom' prop='CurrentPrice' :label="$t('jgjk.s23')" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column sortable='custom' prop='FinalPrice' :label="$t('jgjk.s24')" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column sortable='custom' prop='MonitorPrice' :label="$t('jgjk.s25')" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column sortable='custom' prop='MarginPrice' :label="$t('jgjk.s26')" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column sortable='custom' prop='MarginPercent' :label="$t('report.s38')" width="100" show-overflow-tooltip></el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>      
        <el-table-column prop='ItemCode' label="SPUID" width="180"></el-table-column>
        <el-table-column :label="$t('jgjk.s15')" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.URL" target="_blank">{{ scope.row.ProductName }}</a>
          </template>
        </el-table-column>
        <el-table-column sortable='custom' prop='minMarginPercent' :label="$t('report.s51')" width="100"></el-table-column>
      </el-table>
    </div>

    <div class="pagewrap" v-if="viewmodel == 2">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="pagesize"
        layout="total, prev, pager, next, sizes"
        :total="viewmodel == 1 ? pagingtotalsku : pagingtotalspu">
      </el-pagination>      
    </div>

    <div class="tablebox" v-if="viewmodel == 1">	
      <div class="lowpriced-page-table">
        <div class="searchwrap">
          <el-row :gutter="0">
            <el-col :span="17">
              <el-form :inline="true" class="table-form-inline search-left">
                <el-form-item v-for="(items, index) in selectors.slice(0, 3)" :key="'select' + index" :label="items.label">
                  <el-select v-model="items.default" :placeholder="$t('dsfx.t14')" size="mini" @change="changeSelector(items.action)">
                    <el-option
                      v-for="item in items.options"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('report.s58')" class="switch-check">
                  <el-switch
                    v-model="lowpricechk"
                    active-value="1"
                    inactive-value="2"
                    active-color="#13ce66"
                    inactive-color="#9d9d9d"
                    @change="showLowprice">
                  </el-switch>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="7">
              <div class="tousuxiajiabuttonwrap">
                <el-input 
                  v-model="keywords" 
                  :placeholder="$t('jgjk.s2651')" 
                  size="mini" 
                  @keyup.enter.native="loadTables(page.page, page.size, 71)"
                >
                </el-input>
                <el-button type="danger" @click="loadTables(page.page, page.size, 71)" size="mini">{{ $t('dsfx.t26') }}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <PriceMonitoringTable 
          :tableData="tableData"
          :tableloading="tableloading"
          :pagetotal="pagetotal"
          :showtradeamount="true"
          :setDefaultSort="{prop: 'MarginPercent', order: 'ascending'}"
          :page="page"
        />

      </div>
    </div>

	</div>
</template>

<script>
import PriceMonitoringTable from '@/components/Commons/PriceMonitoringTable.vue'
export default {

  components: {
    PriceMonitoringTable
  },
	data(){
		return{
      getRowKeys(row){
        return row.index
      },
      expands: [],
      defalutbrand: '',
      currentPage: 1,
      pagesize: 25,
      tableviewQuery: {
        page: 1,
        rpstatus: "",
        channel: "",
        result: "",
        bucket: "",
        search: "",
        brand: "",
        authorize: ""
      },
      
      tableloading1: false,
      tableloading2: false,
      
      tableDataSku: [],
      tableDataskulist: [],
      pagingtotal: 0,
      pagingtotalspu: 0,
      pagingtotalsku: 0,
			tableorder: 71,
      series: '',
      model: '',
      showecommerce: false,
      totalproducts: 0,
      viewmodel: 0, //1 sku,2 spu

      
      current: this.getCurrentInfo(),
      selectors: [{
        label: this.$t('jgjk.s12'),
        options: [],
        default: '',
        action: 'channel'
      },{
        label: this.$t('dsfx.t23'),
        options: [{
          name: this.$t('tabletabs.all'),
          value: ''
        },{
          name: this.$t('dsfx.t53'),
          value: 0,
        },{
          name: this.$t('dsfx.t52'),
          value: 1,
        }],
        default: '',
        action: 'authorize'
      },{
        label: this.$t('jgjk.s230'),
        options: [{
          name: this.$t('tabletabs.all'),
          value: ''
        },{
          name: this.$t('jgjk.s231'),
          value: 1,
        },{
          name: this.$t('jgjk.s232'),
          value: 0,
        }],
        default: '',
        action: 'discrepancy'
      }],
      lowpricechk: JSON.parse(localStorage.getItem("lowpricechk")) != null 
                && JSON.parse(localStorage.getItem("lowpricechk")) != undefined 
                && JSON.parse(localStorage.getItem("lowpricechk")) != '' 
                ? JSON.parse(localStorage.getItem("lowpricechk")).val : '2',stocknumchk: 1,
      keywords: '',
      tableloading: false,
      tableData: [],
      pagetotal: 0,
      page: {
        size: 25,
        page: 1
      }
		}
	},

	mounted(){
    let that = this
    that.viewmodel = that.$route.path.indexOf('SPU') != -1 ? 2 : 1
    that.checkLevel()
    that.getChannels()
    that.loadTables(that.page.page, that.page.size, 71)
    if(that.viewmodel == 1){
      that.getLowpricedLists()
    }
    if(that.viewmodel == 2){
      that.getSpuList()
    }
  },

	methods: {

    /**
     * checklevel
     */
    checkLevel: function(){
      let sid = this.$route.params.Id
      let pkglist = JSON.parse(localStorage.getItem("price")).val
      let currentpkg = pkglist.find(o => o.subid/1 === sid/1)
      /**
       * 2：专业版
       * 3：企业版
       */
      let ifshowecommerce = currentpkg.level
      this.showecommerce = ifshowecommerce/1 === 2 || ifshowecommerce/1 === 3 ? true : false
    },

		/**
		 * 每页显示条目数切换
		 */
    handleSizeChange(val) {
      let that = this
      that.currentPage = 1
      that.tableviewQuery.page = 1
      that.pagesize = val
      if(this.viewmodel == 1){
        this.getLowpricedLists()
      }
      if(this.viewmodel == 2){
        this.getSpuList()
      }
		},
		
		/**
		 * 翻页
		 */
    handleCurrentChange(val) {
      this.tableviewQuery.page = val
      if(this.viewmodel == 1){
        this.getLowpricedLists()
      }
      if(this.viewmodel == 2){
        this.getSpuList()
      }
    },

    /**
     * 获取品牌
     */
    getPricemonitoring: function(){
      let that = this
      let priceArr = JSON.parse(localStorage.getItem("price")).val
      for(let i=0; i<priceArr.length; i++){
        if(priceArr[i].subid/1 === that.$route.params.Id/1){
          that.defalutbrand = priceArr[i].name
        }
      }
		},

    /**
     * 列表排序
     */
    sortthiscolumn: function(column){
      if(column.prop == "CurrentPrice" && column.order == "ascending"){
        this.tableorder = 10
        this.reloadTableData()
      }else if(column.prop == "CurrentPrice" && column.order == "descending"){
        this.tableorder = 11
        this.reloadTableData()
      }else if(column.prop == "CurrentPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "FinalPrice" && column.order == "ascending"){
        this.tableorder = 20
        this.reloadTableData()
      }else if(column.prop == "FinalPrice" && column.order == "descending"){
        this.tableorder = 21
        this.reloadTableData()
      }else if(column.prop == "FinalPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "MonitorPrice" && column.order == "ascending"){
        this.tableorder = 30
        this.reloadTableData()
      }else if(column.prop == "MonitorPrice" && column.order == "descending"){
        this.tableorder = 31
        this.reloadTableData()
      }else if(column.prop == "MonitorPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "MarginPrice" && column.order == "ascending"){
        this.tableorder = 40
        this.reloadTableData()
      }else if(column.prop == "MarginPrice" && column.order == "descending"){
        this.tableorder = 41
        this.reloadTableData()
      }else if(column.prop == "MarginPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "MarginPercent" && column.order == "ascending"){
        this.tableorder = 50
        this.reloadTableData()
      }else if(column.prop == "MarginPercent" && column.order == "descending"){
        this.tableorder = 51
        this.reloadTableData()
      }else if(column.prop == "MarginPercent" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "last30times" && column.order == "ascending"){
        this.tableorder = 70
        this.reloadTableData()
      }else if(column.prop == "last30times" && column.order == "descending"){
        this.tableorder = 71
        this.reloadTableData()
      }else if(column.prop == "last30times" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "SkuTotalAmountStr" && column.order == "ascending"){
        this.tableorder = 60
        this.reloadTableData()
      }else if(column.prop == "SkuTotalAmountStr" && column.order == "descending"){
        this.tableorder = 61
        this.reloadTableData()
      }else if(column.prop == "SkuTotalAmountStr" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else{
        return
      }
		},

		/**
		 * 重载数据
		 */
		reloadTableData: function(){
      if(this.viewmodel == 1){
        this.getLowpricedLists()
      }
      if(this.viewmodel == 2){
        this.getSpuList()
      }
		},
		
		/**
		 * 获取低价链接
		 */
		getLowpricedLists: function(){
			
      // let that = this
			// let url = that.API_URL + '/v3/price/statistics/paging'
			// let query ={
      //   project: that.$route.params.Id,
      //   shopid: that.$route.params.Sid,
      //   page: that.tableviewQuery.page,
      //   size: that.pagesize,
      //   order: that.tableorder
			// }
			// that.tableloading = true
      // $.ajax({
      //   url: url,
      //   type: "GET",
      //   changeOrigin: true,
      //   dataType: "json",
      //   contentType: "application/json",
      //   headers: {
      //     Authorization:
      //       "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
      //   },
      //   data: query,
      //   success: function(rex) {
			// 		console.log('getLowpricedLists', rex)
			// 		let data = rex.results[1]
      //     let getNow = that.$moment(new Date()).utc(8)
			// 		data.forEach(item => {
      //       item.AssetIdIcon = that.chkCrawltime(item.crawltime, getNow) ? item.AssetId + ' <i class="icon-newdata-txt">New</i>' : item.AssetId
      //       item.jiamao = that.checkfakeicons('明显假冒', item.itemlab)
      //       item.shangbiao = that.checkfakeicons('滥用商标词', item.itemlab)
      //       item.daotu = that.checkfakeicons('盗图', item.itemlab)
			// 			item.ChannelIcon = that.setChannel(item.Channel).src
      //       item.authorize = item.IsAuthor/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
      //       item.MarginPercent = (item.MarginPercent * 100).toFixed(2) + "%"
      //       item.SkuTotalAmountStr = item.Channel == '拼多多' || item.Channel == '微店' ? 
      //                                 that.setPriorityLevel(item.TotalAmount, 0) : 
      //                                 that.setPriorityLevel(item.TotalAmount, 1)
			// 		})
			// 		that.pagingtotalsku = rex.results[0][0].Count
			// 		that.$store.state.totalproducts = rex.results[0][0].Count
			// 		that.tableDataskulist = data
			// 		that.tableloading = false
      //   },
      //   error: function(response) {
      //     console.log('getLowpricedLists', response)
      //   }
			// })
			
		},

    /**
     * SPU List
     */
    getSpuList: function(){
			
      let that = this
			let url = that.API_URL + '/v3/price/spustatistics/paging'
			let query ={
        project: that.$route.params.Id,
        shopid: that.$route.params.Sid,
        page: that.tableviewQuery.page,
        size: that.pagesize,
        order: that.tableorder
			}
			that.tableloading = true
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: query,
        success: function(rex) {
					console.log('getSpuList', rex)
					let data = rex.results[1]
					data.forEach((item, index) => {
            item.minMarginPercent = (item.minMarginPercent * 100).toFixed(2) + "%"
            item.index = index
					})
					that.pagingtotalspu = rex.results[0][0].Count
					that.$store.state.totalproducts = rex.results[0][0].Count
					that.tableData = data
					that.tableloading = false
        },
        error: function(response) {
          console.log('getLowpricedLists', response)
        }
			})
    },

    /**
     * 获取单品链接
     */
    getProductList: function(row){
			
      let that = this
			let url = that.API_URL + '/v3/price/spustatistics/getlist'
			let query ={
        project: that.$route.params.Id,
        shopId: that.$route.params.Sid,
        page: that.tableviewQuery.page,
        itemCode: row.ItemCode,
        channelId: row.ChannelId,
        size: 1000,
        order: that.tableorder
			}
      let _c = this.expands
      if(row.index == _c[0]) return
      this.expands = []
      this.expands.push(row.index)
			that.tableloading1 = true
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: query,
        success: function(response) {
					let data = response.results[1]
					that.tableData = that.formatTablefields(data)
					that.pagetotal = response.results[0][0].Count
					that.tableloading = false
					// console.log('getLowpricedLists', rex)
          // let _list = rex.results[1]
          // _list.forEach(item => {
          //   item.SkuTotalAmountStr = item.Channel == '拼多多' || item.Channel == '微店' ? 
          //                             that.setPriorityLevel(item.TotalAmount, 0) : 
          //                             that.setPriorityLevel(item.TotalAmount, 1)
          // })
          // that.tableDataSku[row.index] = _list
          // that.tableloading1 = false
        },
        error: function(response) {
          console.log('getLowpricedLists', response)
        }
			})
      
    },

    /**
     * 查看详情
     */
    viewUrlDetail: function(mid, name, skuid){
      this.setLocalStorage( "viewurlDetail", '' )
      let MidName = name
      this.setLocalStorage( "viewurlDetail", MidName )
      this.$router.push({name: 'ViewUrlDetail1', params: {Id: this.$route.params.Id, SkuId: skuid, Mid: mid}})
    },

    /**
     * 判断是否一天内
     */
    chkCrawltime: function(ctime, ntime){
      if(ctime){
        if(this.$moment(ntime).diff(this.$moment(ctime),'hours') < 24){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },


    /**
     * 选择条件筛选
     */
    changeSelector: function(){
      let that = this
      that.loadTables(that.page.page, that.page.size, 71)
    },

    /**
     * 获取渠道列表
     */
    getChannels: function(){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/filter'
      let data = {
        skuid: '',
        taskid: that.current.taskid,
        channel: '',
        authorize: '',
        search: '',
      }
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(response) {
          let _all = {
            name : that.$t('tabletabs.all'),
            value : ''
          }
          that.selectors[0].options = response.results[1].map(function(val){
            return {
              name: that.setChannel(val.Channel).loc,
              value: val.Channel
            }
          })
          that.selectors[0].options.unshift(_all)
        },
        error: function(errors) {
          console.log('getChannels', errors)
        }
      })      
    },

    /**
     * 显示低价/全部
     */
    showLowprice: function(){
      let that = this
      this.setLocalStorage( "lowpricechk", val)
      that.loadTables(that.page.page, that.page.size, 71)
    },

    /**
     * 显示零库存
     */
    showZerostock: function(){
      let that = this
      if(that.stocknumchk == '0'){
        that.setLocalStorage( "stocknum", '0')
      }
      if(that.stocknumchk == '1'){
        that.setLocalStorage( "stocknum", '1' )
      }
      that.loadTables(that.page.page, that.page.size, 71)
    },

    /**
     * 加载数据列表
     */
    loadTables: function(_page, _size, _order){
      let that = this
      let _url = that.API_URL + '/v3/price/statistics/paging'
      let _query = {
        project: that.$route.params.Id,
        shopid: that.$route.params.Sid,
        page: _page,
        size: _size,
        order: _order,
        channel: that.selectors[0].default,
        authorize: that.selectors[1].default,
        discrepancy: that.selectors[2].default,
        stockNum: that.stocknumchk == 0 ? 0 : 1,
        all: that.lowpricechk,
        search: that.keywords,
      }
      that.tableloading = true
      $.ajax({
        url: _url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: _query,
        success: function(response) {
					let data = response.results[1]
					that.tableData = that.formatTablefields(data)
					that.pagetotal = response.results[0][0].Count
          that.$store.state.totalproducts = response.results[0][0].Count
					that.tableloading = false
        },
        error: function(errors) {
          console.log('loadTables', errors)
        }
			})
    },

		
	}
	
}
</script>
